const $searchBtn = $(".js-search-btn");
const $searchPopup = $(".js-popup-search");
const $searchPopupOverlay = $(".js-popup-search-overlay");
const $document = $(document);
const $clearBtn = $(".clear-search-button");

$searchBtn.on("click", function () {
  $searchPopup.addClass("is-active");
  $(".js-popup-search-overlay").addClass("is-active");
});

$document.keyup(function (e) {
  if (e.key === "Escape") {
    $searchPopup.removeClass("is-active");
    $(".js-popup-search-overlay").removeClass("is-active");
  }
});

$document.on("click", function (evn) {
  const $target = $(evn.target);

  if (
    !$target.closest($searchBtn).length &&
    !$target.closest($searchPopup).length
  ) {
    $searchPopup.removeClass("is-active");
    $(".js-popup-search-overlay").removeClass("is-active");
  }
});

$clearBtn.on("click", function (e) {
  $(".search__field").val("");
  e.preventDefault();
});

$("form[role='search']").on("submit", function (e) {
  if ($(this).children(".search__field").val() == "") {
    e.preventDefault();
    return false;
  }
});
